import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Cookie from "js-cookie";
import Routes from "./routes";
import RenderMetaTags from "./components/SEO";
import AgeGate from "./components/AgeGate";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import smoothscroll from "smoothscroll-polyfill";
import { ThemeProvider } from "@material-ui/core/styles";
import { theme } from "./theme";
import "./css/styles.css";
import Dialogs from "./components/Dialog";
import ReduxDevTools from "./components/ReduxDevTools";
import { isLocalhost } from "./utils/Utils";

var pjson = require("../package.json");

console.log(`Version: ${pjson.version}`);

export default function App() {
  smoothscroll.polyfill();

  const dispatch = useDispatch();
  const location = useLocation();

  const isPrivacyPolicy =
    location.pathname === "/privacy-policy" ||
    location.pathname === "/terms-of-service";

  const isStaging =
    window.location.hostname.includes("localhost") ||
    window.location.hostname.includes("crescolabsdev");

  const over21cookie = Cookie.get("sunnyside_wellness_over21") || false;

  const [ageVerified, setAgeVerified] = useState(over21cookie);

  const verifyAge = () => {
    setAgeVerified(true);
  };

  useEffect(() => {
    dispatch({
      type: "INITIALIZE_APP",
    });
    dispatch({
      type: "ACCESSIBILITY/CHECK",
    });
  }, [dispatch]);

  useEffect(() => {
    if (isPrivacyPolicy) {
      setAgeVerified(isPrivacyPolicy);
    } else {
      setAgeVerified(over21cookie);
    }
  }, [isPrivacyPolicy, over21cookie]);

  return (
    <ThemeProvider theme={theme}>
      <RenderMetaTags pathname={location.pathname} />
      <ScrollToTop>
        <Dialogs />
        {isLocalhost && <ReduxDevTools />}
        {!ageVerified && <AgeGate verifyAge={verifyAge} />}
        <div className="app-shell">
          <Header activePage={location.pathname} />
          <main className="app-main no-flick">
            <Routes isStaging={isStaging} />
          </main>
          <Footer />
        </div>
      </ScrollToTop>
    </ThemeProvider>
  );
}
